import SupportQuery from "../../components/SupportQuery";

const SupportQueryPage = () => {
  return <SupportQuery />;
};

export default SupportQueryPage;
